/**
 * Cart strikethrough free item promo
 * Reads the json metafield from the fgw-bottle-promo-discount app extension.
 */

class WICartStrikethroughPromo extends HTMLElement {
  static observedAttributes = ["data-bottle-count"];

  /**
   * @type {any}
   */
  promoConfig = {};

  targetBottles = 0;

  constructor() {
    super();

    const configEl = this.querySelector('[data-config]');
    if (!configEl) {
      console.error('Config element not found');
      return;
    }

    try {
      this.promoConfig = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('Failed parsing config JSON', e);
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = this.promoConfig.skuQueryParam;
    if (!queryParam) {
      return;
    }
    if (searchParams.has(queryParam)) {
      const promoSku = searchParams.get(queryParam);
      if (promoSku) {
        localStorage.setItem('wi_st_promo_sku', promoSku);
      }
    }
  }

  connectedCallback() {
  }

  disconnectedCallback() {
  }

  /**
   * Attribute change somewhat takes the place of connectedCallback here. It will fire
   * before connectedCallback, and on every attribute change (which fires every time the cart updates)
   * 
   * @param {string} name 
   * @param {string} oldValue 
   * @param {string} newValue 
   */
  attributeChangedCallback(name, oldValue, newValue) {
    const promoSku = localStorage.getItem('wi_st_promo_sku');
    if (!promoSku) {
      this.hideContainer();
      return;
    }

    const matchedPromo = this.promoConfig.promos.find((/** @type {any} */ promo) => promo.product.sku === promoSku);
    if (!matchedPromo) {
      this.hideContainer();
      return;
    }

    const now = Date.now();
    const promoStart = new Date(matchedPromo.startsAt).getTime();
    const promoEnd = new Date(matchedPromo.endsAt).getTime();

    if (now < promoStart || now > promoEnd) {
      this.hideContainer();
      return;
    }

    this.showContainer();
    this.targetBottles = matchedPromo.bottleQuantity;
    this.updateProgress();
  }

  updateProgress() {
    const currentBottleCount = this.dataset.bottleCount ? parseInt(this.dataset.bottleCount) : 0;
    const messageElement = this.querySelector('[data-message]');
    const progressElement = this.querySelector('[data-progress]');
    if (!messageElement) {
      console.error("Missing element: 'data-message'");
      return;
    }
    if (!progressElement) {
      console.error("Missing element: 'data-progress'");
      return;
    }
    if (currentBottleCount < this.targetBottles) {
      const text = this.promoConfig.progressText.replace('{count}', this.targetBottles - currentBottleCount);
      messageElement.innerHTML = `<span>${text}</span>`
      progressElement.setAttribute('style', `--progress: ${(currentBottleCount / this.targetBottles) * 100}%;`);
    }
    if (currentBottleCount === this.targetBottles) {
      const icon = this.promoConfig.completeIcon;
      const text = this.promoConfig.completeText;
      messageElement.innerHTML = `${icon} <span>${text}</span>`;
      progressElement.setAttribute('style', '--progress: 100%;');
    }
    if (currentBottleCount > this.targetBottles) {
      const text = this.promoConfig.overText.replace('{limit}', this.targetBottles);
      messageElement.innerHTML = `<span>${text}</span>`
      progressElement.setAttribute('style', '--progress: 75%;');
    }
  }

  hideContainer() {
    const container = this.querySelector('[data-container]');
    if (!container) {
      console.error('[data-container] not found.');
      return;
    }
    container.classList.add('hidden');
  }

  showContainer() {
    const container = this.querySelector('[data-container]');
    if (!container) {
      console.error('[data-container] not found.');
      return;
    }
    container.classList.remove('hidden');
  }
}

if (!customElements.get('wi-cart-st-promo-progress')) {
  customElements.define('wi-cart-st-promo-progress', WICartStrikethroughPromo);
}